import {
  MENDELEEV_HOST,
  // MENDELEEV_INSTANCE,
} from '@/helper/consts'
import { getUrlAllowed, getUrlWithParameters } from '@/helper/urls'

export default {
  getMendeleevUrlWithParameters: function (name, method, parameters, gets) {
    return getUrlWithParameters(
      MENDELEEV_HOST.slice(0, -1), "urls", name, method, parameters, gets
    )
  },

  getMendeleevUrlAllowed (name, method) {
    return getUrlAllowed("urls", name, method)
  }
}
